import React, {useState} from 'react';
import clsx from 'clsx';
import Select, {components, DropdownIndicatorProps, ClearIndicatorProps, MultiValueRemoveProps} from 'react-select';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

const DropdownIndicator = (props: DropdownIndicatorProps) => {
    return (
        <components.DropdownIndicator {...props}>
            <KeyboardArrowDownOutlinedIcon />
        </components.DropdownIndicator>
    );
};

const ClearIndicator = (props: ClearIndicatorProps) => {
    return (
        <components.ClearIndicator {...props}>
            <CloseIcon />
        </components.ClearIndicator>
    );
};

const MultiValueRemove = (props: MultiValueRemoveProps) => {
    return (
        <components.MultiValueRemove {...props}>
            <CloseIcon />
        </components.MultiValueRemove>
    );
};

const controlStyles = {
    base: 'border rounded-[8px] min-h-[12px] bg-white hover:cursor-pointer dark:bg-gray-900 ',
    baseDisable: 'border rounded-[8px] min-h-[12px] bg-gray-50 hover:cursor-pointer dark:bg-gray-800 ',
    focus: 'border-blue-500 ring-1 ring-primary-500 dark:focus:ring-blue-500 ',
    nonFocus: 'border-gray-300 dark:border-gray-600',
};
const placeholderStyles = 'text-gray-900 dark:text-white pl-1 py-0.5';
const selectInputStyles = 'pl-1 py-0.5 dark:text-white w-36';
const valueContainerStyles = 'p-1 gap-1 dark:text-white ';
const singleValueStyles = 'leading-7 ml-1 ';
const multiValueStyles = 'bg-gray-100 rounded items-center py-0.5 pl-2 pr-1 gap-1.5 dark:text-white';
const multiValueLabelStyles = 'leading-6 py-0.5 ';
const multiValueRemoveStyles = 'border border-gray-200 bg-white hover:bg-red-50 hover:text-red-800 text-gray-500 dark:text-white hover:border-red-300 rounded-md';
const indicatorsContainerStyles = 'p-1 gap-1 ';
const clearIndicatorStyles = 'text-gray-500 p-1 rounded-[8px] hover:bg-red-50 hover:text-red-800';
const indicatorSeparatorStyles = 'bg-gray-300 ';
const dropdownIndicatorStyles = 'p-1 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-white rounded-[8px] hover:text-black';
const menuStyles = 'p-1 mt-2 border border-gray-200 dark:border-gray-600 bg-white dark:text-white dark:bg-gray-900 rounded-[8px]';
const groupHeadingStyles = 'ml-3 mt-2 mb-1 text-gray-500 dark:text-white';
const optionStyles = {
    base: 'hover:cursor-pointer px-3 rounded h-12 ',
    focus: 'bg-blue-200 dark:bg-blue-500 h-12 active:bg-gray-200  dark:focus:border-blue-500',
    selected: "after:content-['✔'] after:ml-2 after:text-blue-500 dark:after:text-white text-gray-900 dark:text-white",
};
const noOptionsMessageStyles = 'text-gray-500 p-2 bg-gray-50 dark:bg-gray-900 dark:border-gray-600 border border-dashed border-gray-200 rounded-[8px]';

const ReactSelect = ({value, options, onChange, onInputChange, noOptionsMessage, isDisabled, placeholder, ...props}) => (
    <Select
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        unstyled
        styles={{
            input: base => ({
                ...base,
                'input:focus': {
                    boxShadow: 'none',
                },
            }),
            multiValueLabel: base => ({
                ...base,
                whiteSpace: 'normal',
                overflow: 'visible',
            }),
            control: base => ({
                ...base,
                transition: 'none',
            }),
        }}
        components={{DropdownIndicator, ClearIndicator, MultiValueRemove}}
        classNames={{
            control: ({isFocused, isDisabled}) => clsx(isFocused ? controlStyles.focus : controlStyles.nonFocus, isDisabled ? controlStyles.baseDisable : controlStyles.base),

            placeholder: () => placeholderStyles,
            input: () => selectInputStyles,
            valueContainer: () => valueContainerStyles,
            singleValue: () => singleValueStyles,
            multiValue: () => multiValueStyles,
            multiValueLabel: () => multiValueLabelStyles,
            multiValueRemove: () => multiValueRemoveStyles,
            indicatorsContainer: () => indicatorsContainerStyles,
            clearIndicator: () => clearIndicatorStyles,
            indicatorSeparator: () => indicatorSeparatorStyles,
            dropdownIndicator: () => dropdownIndicatorStyles,
            menu: () => menuStyles,
            groupHeading: () => groupHeadingStyles,
            option: ({isFocused, isSelected}) => clsx(isFocused && optionStyles.focus, isSelected && optionStyles.selected, optionStyles.base),
            noOptionsMessage: () => noOptionsMessageStyles,
        }}
        value={value}
        options={options}
        onChange={onChange}
        onInputChange={onInputChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        noOptionsMessage={() => noOptionsMessage}
        {...props}
    />
);

function SelectMaquinaProposta({value, options, onChange, onInputChange, noOptionsMessage, placeholder, isDisabled, sort = true, isClearable = false, onMenuOpen}) {
    const sortedOptions = Array.isArray(options) ? (sort ? options.slice().sort((a, b) => a.label.localeCompare(b.label)) : options.slice()) : [];

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    // const [isClearable, setIsClearable] = useState(true);

    const handleMenuOpen = () => {
        setIsMenuOpen(true);
        if (onMenuOpen) {
            onMenuOpen();
        }
    };

    const handleMenuClose = () => {
        setIsMenuOpen(false);
    };
    // const handleClick = () => {
    //     onClick();
    // };

    return (
        <ReactSelect
            value={value}
            options={sortedOptions}
            onChange={selectedOption => {
                onChange(selectedOption);
                handleMenuClose();
            }}
            noOptionsMessage={noOptionsMessage}
            placeholder={placeholder}
            onInputChange={onInputChange}
            isDisabled={isDisabled}
            onMenuOpen={handleMenuOpen}
            onMenuClose={handleMenuClose}
            menuIsOpen={isMenuOpen}
            isClearable={isClearable}
            // onClick={handleClick}
        />
    );
}

export default SelectMaquinaProposta;
